import images from "./images";

const services = [
    {
        image: `${images.services_img_1}`,
        title: "Gestión de Alquileres",
        paragraph: "Ofrecemos servicios de gestión integral de alquileres para maximizar el rendimiento de tus propiedades inmobiliarias. Gestionamos alquileres temporales y a largo plazo para generar ingresos óptimos."
    },
    {
        image: `${images.services_img_2}`,
        title: "Buy2Rent",
        paragraph: "Especialistas en Buy2Rent: adquirimos propiedades estratégicas y las alquilamos para proporcionar rentabilidad sostenible a nuestros clientes inversores."
    },
    {
        image: `${images.services_img_3}`,
        title: "Flipping House",
        paragraph: "Transformamos propiedades con nuestro servicio de Flipping House. Reformamos y vendemos inmuebles rápidamente para obtener ganancias en el mercado inmobiliario."
    },
    {
        image: `${images.services_img_4}`,
        title: "Cambio de Uso",
        paragraph: "Asesoramos en cambios de uso de propiedades, desde residencial a comercial o turístico, cumpliendo con todas las normativas legales y maximizando el valor."
    },
    {
        image: `${images.services_img_5}`,
        title: "Alquiler Turístico",
        paragraph: "Gestionamos alquileres turísticos de corta duración, optimizando plataformas como Airbnb para maximizar ingresos y minimizar vacantes."
    },
    {
        image: `${images.services_img_6}`,
        title: "Consultoría Inmobiliaria",
        paragraph: "Proporcionamos consultoría experta en inversiones inmobiliarias, análisis de mercado y estrategias para proteger y hacer crecer tu patrimonio. Con Xardy, tus inversiones están en buenas manos."
    }
];


const works = [
    {
        image: `${images.shoes_website}`
    },
    {
        image: `${images.work_img_2}`
    },
    {
        image: `${images.work_img_3}`
    },
    {
        image: `${images.work_img_4}`
    },
    {
        image: `${images.work_img_5}`
    },
    {
        image: `${images.work_img_6}`
    },
];

const work_process = [
    {
        title: "Evaluación",
        paragraph: "En la fase de evaluación, recopilamos tus requisitos y necesidades para analizar la viabilidad de tu proyecto inmobiliario. Esto nos ayuda a planificar la estrategia óptima."
    },
    {
        title: "Planificación",
        paragraph: "En la fase de planificación, desarrollamos un plan detallado con cronogramas, presupuestos y objetivos claros. Aseguramos que todo esté alineado con tus expectativas."
    },
    {
        title: "Ejecución",
        paragraph: "En la fase de ejecución, llevamos a cabo el proyecto con nuestro equipo experto. Seguimos las mejores prácticas para garantizar resultados eficientes y de alta calidad."
    },
    {
        title: "Entrega",
        paragraph: "En la fase final, realizamos verificaciones exhaustivas para asegurar que todo cumpla con los estándares más altos. Una vez aprobado, entregamos el proyecto completo."
    },
];

const about_stats = [
    {
        image: `${images.stat_img_1}`,
        value: "+150",
        title: "Clientes"
    },
    {
        image: `${images.stat_img_2}`,
        value: "+25",
        title: "Proyectos"
    },
    {
        image: `${images.stat_img_3}`,
        value: "+4000",
        title: "Horas de Trabajo"
    },
    {
        image: `${images.stat_img_4}`,
        value: "+15",
        title: "Premios"
    },
];

const testimonials = [
    {
        name: "María López",
        post: "Propietaria de Vivienda",
        paragraph: "Trabajar con Tu Inquilino Ideal ha sido una experiencia excelente. Su servicio de Rent2Rent me ha permitido generar ingresos pasivos sin preocupaciones. ¡Altamente recomendado!"
    },
    {
        name: "Carlos Ruiz",
        post: "Inversor Inmobiliario",
        paragraph: "Estoy impresionado con la profesionalidad y expertise de Tu Inquilino Ideal. Han convertido mis propiedades en inversiones rentables con su modelo Buy2Rent."
    },
    {
        name: "Ana García",
        post: "Emprendedora",
        paragraph: "Tu Inquilino Ideal entiende perfectamente las necesidades del mercado inmobiliario. Su consultoría ha sido clave para el éxito de mis proyectos de inversión."
    },
    {
        name: "Javier Martínez",
        post: "Propietario de Inmuebles",
        paragraph: "Tu Inquilino Ideal ha transformado mi portafolio inmobiliario. Sus estrategias de inversión son impecables y los resultados hablan por sí solos."
    },
    {
        name: "Laura Sánchez",
        post: "Agente Inmobiliaria",
        paragraph: "Como profesional del sector, recomiendo Tu Inquilino Ideal sin dudarlo. Su expertise en Buy2Rent y gestión de alquileres es excepcional."
    },
    {
        name: "Roberto Díaz",
        post: "Empresario",
        paragraph: "Invertir con Tu Inquilino Ideal me ha dado tranquilidad financiera. Su equipo es profesional y los rendimientos son consistentes."
    },
];

const logos = [
    {
        image: `${images.logo_img_1}`
    },
    {
        image: `${images.logo_img_2}`
    },
    {
        image: `${images.logo_img_3}`
    },
    {
        image: `${images.logo_img_4}`
    },
    {
        image: `${images.test_img_5}`
    },
    {
        image: `${images.test_img_6}`
    },
];

export {services, works, work_process, about_stats, testimonials, logos};
